import { render } from "./PaginaExtras.vue?vue&type=template&id=1e412a70"
import script from "./PaginaExtras.vue?vue&type=script&lang=js"
export * from "./PaginaExtras.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__